import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SecurityPrivacyCookiePolicyComponent } from '../../../components/security-privacy-cookie-policy/security-privacy-cookie-policy.component';
import { TermsAndConditionsComponent } from '../../../components/terms-and-conditions/terms-and-conditions.component';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-start-page-notices',
  templateUrl: './start-page-notices.component.html',
  styleUrl: './start-page-notices.component.scss'
})
export class StartPageNoticesComponent {


  constructor(private matDialog: MatDialog) {

    this.noticesForm.get('termsAndConditions')?.valueChanges.subscribe(value => {
      this.onTermsChange({ checked: value });
    });

}
@Input() nextClicked: boolean = false;
 @Output() termsChanged = new EventEmitter<boolean>();

  noticesForm = new FormGroup({
    termsAndConditions: new FormControl(false)
  });

  onTermsChange(event: any) {
    this.termsChanged.emit(event.checked);
  }

  showSecurityPrivacyCookiePolicyModal() {

  var privacyDialog = this.matDialog.open(SecurityPrivacyCookiePolicyComponent, { panelClass: 'dialog-panel-large',  data: { appName: 'AssessmentApp' } });
  }
  
  openTermsAndConditionsDialog(event?: Event){
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    var termsDialog = this.matDialog.open(TermsAndConditionsComponent, { panelClass: 'dialog-panel-large', data: { appName: 'AssessmentApp' }});
  }


}